/* Operação (sprint-15-spec §2.5 e §2.6): remoção de dados pessoais e rótulo da versão. */

const EMAIL = /[\w.+-]+@[\w-]+(?:\.[\w-]+)+/g
/** CPF com ou sem máscara (11 dígitos). */
const CPF = /\b\d{3}\.?\d{3}\.?\d{3}-?\d{2}\b/g
/** Telefone brasileiro: DDI e DDD opcionais, 8 ou 9 dígitos, com ou sem separadores. */
const PHONE = /(?:\+?55[\s-]?)?(?:\(?\d{2}\)?[\s-]?)?9?\d{4}[\s-]?\d{4}\b/g
/** Sobra: qualquer sequência longa de dígitos (documento, cartão, telefone sem padrão). */
const LONG_DIGITS = /\d{8,}/g
/** Mais de 11 dígitos seguidos (cartão, protocolo): sai antes para não virar meio telefone. */
const VERY_LONG_DIGITS = /\d{12,}/g

/** Troca e-mail, CPF e telefone por marcadores antes de logar texto que veio do navegador. */
export function scrubPersonalData(text: string): string {
  return text
    .replace(EMAIL, '[email]')
    .replace(VERY_LONG_DIGITS, '[numero]')
    .replace(CPF, '[cpf]')
    .replace(PHONE, '[telefone]')
    .replace(LONG_DIGITS, '[numero]')
}

/** Commit curto (7 caracteres) para exibir. */
export const shortSha = (sha: string | null | undefined): string | null =>
  sha ? sha.trim().slice(0, 7) || null : null
